// extracted by mini-css-extract-plugin
module.exports = {"wrap":"press_release_wrap__Uq6-N","body":"press_release_body__1e5qG","preview":"press_release_preview__2_f1e","check":"press_release_check__i1cHV","nav":"press_release_nav__3Cpv_"};